export const comingSoonCityScreen = {
    event: "coming_soon_city_screen",
    eventAction: "coming_soon_city_screen"
};

export const homepageCitySelection = {
    event: "City click on Pop-up",
    eventCategory: "homepage",
    eventAction: "cityPopup",
    eventLabel: "citySelection"
};

export const pincodeSelected = {
    event: "pincode_selected",
    eventAction: "pincode_selected"
};

export const setupLocationPopup = {
    event: "setupLocationPopup",
    eventAction: "setupLocationPopup"
};

const locationPopupCategory = "Buy_used_cars_B2C_Location";

export const fetchedLocationSucess = {
    event: "new_location",
    eventCategory: locationPopupCategory,
    eventAction: "location | fetch_location_success"
};

export const currentLocation = {
    event: "new_location",
    eventCategory: locationPopupCategory,
    eventAction: "location | use_current_location"
};
